module.exports = __webpack_public_path__ + "img/haft-poznan-slider.e400081b.jpg";